import React, { useMemo, useState } from "react";
import { useDeveloperModeFlag } from "../scheduling/developerModeTools";
import "./AdminSettings.css";

const DEV_MODE_PASSWORD = "1098";

export default function AdminSettings() {
  const { isDeveloperMode, setIsDeveloperMode } = useDeveloperModeFlag();
  const [isUnlockModalOpen, setIsUnlockModalOpen] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const statusLabel = useMemo(
    () => (isDeveloperMode ? "Enabled" : "Disabled"),
    [isDeveloperMode]
  );

  const closeModal = () => {
    setIsUnlockModalOpen(false);
    setPasswordInput("");
    setPasswordError("");
  };

  const handleToggleRequest = () => {
    if (isDeveloperMode) {
      setIsDeveloperMode(false);
      return;
    }
    setIsUnlockModalOpen(true);
    setPasswordError("");
    setPasswordInput("");
  };

  const handleEnableDeveloperMode = () => {
    if (passwordInput !== DEV_MODE_PASSWORD) {
      setPasswordError("Incorrect password.");
      return;
    }
    setIsDeveloperMode(true);
    closeModal();
  };

  return (
    <div className="adminSettingsPage">
      <div className="adminSettingsCard">
        <div className="adminSettingsHeader">
          <h2>Settings</h2>
          <p>Manage admin-only tools.</p>
        </div>

        <div className="adminSettingRow">
          <div>
            <div className="adminSettingTitle">Development Mode</div>
            <div className="adminSettingDescription">
              Enables schedule overrides for past-session editing.
            </div>
          </div>

          <div className="adminSettingActions">
            <span className={`adminSettingStatus ${isDeveloperMode ? "is-on" : "is-off"}`}>
              {statusLabel}
            </span>
            <button
              type="button"
              className={`adminToggleButton ${isDeveloperMode ? "is-on" : "is-off"}`}
              onClick={handleToggleRequest}
            >
              {isDeveloperMode ? "Disable" : "Enable"}
            </button>
          </div>
        </div>
      </div>

      {isUnlockModalOpen && (
        <div className="adminSettingsModalOverlay" onMouseDown={closeModal}>
          <div className="adminSettingsModal" onMouseDown={(e) => e.stopPropagation()}>
            <div className="adminSettingsModalTitle">Enable Development Mode</div>
            <div className="adminSettingsModalText">Enter password to continue.</div>
            <input
              type="password"
              className="adminSettingsPasswordInput"
              value={passwordInput}
              onChange={(e) => {
                setPasswordInput(e.target.value);
                if (passwordError) setPasswordError("");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleEnableDeveloperMode();
                }
              }}
              autoFocus
            />
            {passwordError ? <div className="adminSettingsError">{passwordError}</div> : null}
            <div className="adminSettingsModalActions">
              <button type="button" className="adminSettingsBtn" onClick={closeModal}>
                Cancel
              </button>
              <button type="button" className="adminSettingsBtn adminSettingsBtnPrimary" onClick={handleEnableDeveloperMode}>
                Enable
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
